(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Announcement-bar-fade"] && !Shopify.designMode) return;
  try {
    
(function () {
  const messages = document.querySelectorAll(".announcement-bar-slider__message");
  if (messages.length === 0) return;

  let index = 0;
  const speed = (parseInt("{{ section.settings.speed | default: 5 }}") || 5) * 1000;

  function show(indexToShow) {
    messages.forEach((msg, i) => {
      msg.classList.toggle("active", i === indexToShow);
    });
  }

  setInterval(() => {
    index = (index + 1) % messages.length;
    show(index);
  }, speed);

  show(index);
})();

  } catch(e) { console.error(e); }
})();
})();
